import React, { useContext, useState } from 'react';

import { IdentityContext } from '../../context';
import { useIndex } from '../../hooks';
import { HealthcareDirective } from '../../types';

import { NewHDContext } from './new-hd-composer';
import { NewHDGuard } from './new-hd-guard';

export function NewHDProvider() {
  const { person } = useContext(IdentityContext);
  const { data, loading, update } = useIndex('healthcare_directives', { person_id: person?.id });
  // check if user has a healthcare directive
  const [ initLoad, setInitLoad ] = useState(true);
  const [ newHD, setNewHD ] = useState({} as HealthcareDirective);
  
  if (loading) {
    return <div>Loading healthcare directive...</div>;
  }
  
  const healthcareDirective = data[0];
  
  return (
    <NewHDContext.Provider value={{ healthcareDirective, update, newHD, setNewHD }}>
      <NewHDGuard initLoad={initLoad} setInitLoad={setInitLoad} />
    </NewHDContext.Provider>
  );
}
  
  